import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { canActivatePermiso, canActivatePermisoFormulario } from 'app/core/auth/guards/permiso.guard';
import { ACCION, MODULO } from 'app/core/permisos/permiso.constants';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboards/project'
    {path: '', pathMatch : 'full', redirectTo: '404-not-found'},

    // Redirect signed-in user to the '/dashboards/project'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'funcionariogeneral'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'password-reset', loadChildren: () => import('app/modules/auth/password-reset/password-reset.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
             // pantalla principal 
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
             // kiosko autosvicio
            {path: 'kioskoautoservicio', loadChildren: () => import('app/modules/landing/kioskoautoservicio/kioskoautoservicio.routes')},
             // kiosko apoyo funcionario
            {path: 'kiosko', loadChildren: () => import('app/modules/landing/kiosko/kiosko.routes')},
        ]
    },

    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [


            // Funcionario1. Trámites en sala
            {path: 'funcionariogeneral', loadChildren: () => import('app/modules/admin/funcionariogeneral/funcionariogeneral.routes')}, 

            // Funcionario2. Turno en atención
            {path: 'funcionarioturnoenatencion', loadChildren: () => import('app/modules/admin/funcionarioturnoenatencion/funcionarioturnoenatencion.routes')},

             // Funcionario3. Monitoreo del modulo
            {path: 'funcionariomonitoreo', loadChildren: () => import('app/modules/admin/funcionariomonitoreo/funcionariomonitoreo.routes')},

            // Admin1. Dashboard Admin
            {path: 'dashadmin', loadChildren: () => import('app/modules/admin/dashadmin/dashadmin.routes')},

            // Admin. Catalogos form de registro
            {path: 'formdependencia', loadChildren: () => import('app/modules/admin/formdependencia/formdependencia.routes')},
            {path: 'formtramite', canActivate: [canActivatePermisoFormulario(MODULO.TRAMITES)], loadChildren: () => import('app/modules/admin/formtramite/formtramite.routes')},
            {path: 'formusuario', canActivate: [canActivatePermisoFormulario(MODULO.USUARIOS)], loadChildren: () => import('app/modules/admin/formusuario/formusuario.routes')},
            {path: 'formmodulo', canActivate: [canActivatePermisoFormulario(MODULO.PUESTOS)], loadChildren: () => import('app/modules/admin/formmodulo/formmodulo.routes')},
            {path: 'formkiosko', canActivate: [canActivatePermisoFormulario(MODULO.KIOSKOS)], loadChildren: () => import('app/modules/admin/formkiosko/formkiosko.routes')},
            {path: 'formsala', canActivate: [canActivatePermisoFormulario(MODULO.SALAS)], loadChildren: () => import('app/modules/admin/formsala/formsala.routes')},
            {path: 'formsucursales', canActivate: [canActivatePermisoFormulario(MODULO.SUCURSALES)], loadChildren: () => import('app/modules/admin/formsucursales/formsucursales.routes')},
            {path: 'formtramitesderivable', loadChildren: () => import('app/modules/admin/formtramitesderivable/formtramitesderivable.routes')},
            {path: 'formperfil', canActivate: [canActivatePermisoFormulario(MODULO.PERFILES_SEGURIDAD)], loadChildren: () => import('app/modules/admin/formperfil/formperfil.routes')},
            {path: 'formgrupo', canActivate: [canActivatePermisoFormulario(MODULO.GRUPOS)], loadChildren: () => import('app/modules/admin/formgrupo/formgrupo.routes')},
            {path: 'formmultimedia', canActivate: [canActivatePermisoFormulario(MODULO.MULTIMEDIA)], loadChildren: () => import('app/modules/admin/formmultimedia/formmultimedia.routes')},
            {path: 'formpermiso', canActivate: [canActivatePermisoFormulario(MODULO.PERMISOS)], loadChildren: () => import('app/modules/admin/formpermiso/formpermiso.routes')},
            {path: 'formavisos', canActivate: [canActivatePermisoFormulario(MODULO.AVISOS)], loadChildren: () => import('app/modules/admin/formavisos/formavisos.routes')},
            {path: 'formtelefonobloqueado', canActivate: [canActivatePermisoFormulario(MODULO.TELEFONOS_BLOQUEADOS)], loadChildren: () => import('app/modules/admin/formtelefonobloqueado/formtelefonobloqueado.routes')},
            {path: 'formipbloqueada', canActivate: [canActivatePermisoFormulario(MODULO.IPS_BLOQUEADAS)], loadChildren: () => import('app/modules/admin/formipbloqueada/formipbloqueada.routes')},
            {path: 'formcita', canActivate: [canActivatePermisoFormulario(MODULO.CITAS)], loadChildren: () => import('app/modules/admin/formcita/formcita.routes')},
            {path: 'formlimitecanal', canActivate: [canActivatePermisoFormulario(MODULO.LIMITES_CANAL)], loadChildren: () => import('app/modules/admin/formlimitecanal/formlimitecanal.routes')},

            // Admin. Catalogos concentrado
            {path: 'tabladependencia', loadChildren: () => import('app/modules/admin/tabladependencia/tabladependencia.routes')},
            {path: 'tablamodulo', canActivate: [canActivatePermiso(MODULO.PUESTOS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablamodulo/tablamodulo.routes')},
            {path: 'tablasala', canActivate: [canActivatePermiso(MODULO.SALAS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablasala/tablasala.routes')},
            {path: 'tablatramites', canActivate: [canActivatePermiso(MODULO.TRAMITES, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablatramites/tablatramites.routes')},
            {path: 'tablausuario', canActivate: [canActivatePermiso(MODULO.USUARIOS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablausuario/tablausuario.routes')},
            {path: 'tablaperfil', canActivate: [canActivatePermiso(MODULO.PERFILES_SEGURIDAD, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablaperfil/tablaperfil.routes')},
            {path: 'tablagrupo', canActivate: [canActivatePermiso(MODULO.GRUPOS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablagrupo/tablagrupo.routes')},
            {path: 'tablamultimedia', canActivate: [canActivatePermiso(MODULO.MULTIMEDIA, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablamultimedia/tablamultimedia.routes')},
            {path: 'tablaavisos', canActivate: [canActivatePermiso(MODULO.AVISOS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablaavisos/tablaavisos.routes')},
            {path: 'tablatelefonosbloqueados', canActivate: [canActivatePermiso(MODULO.TELEFONOS_BLOQUEADOS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablatelefonosbloqueados/tablatelefonosbloqueados.routes')},
            {path: 'tablaipsbloqueadas', canActivate: [canActivatePermiso(MODULO.IPS_BLOQUEADAS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablaipsbloqueadas/tablaipsbloqueadas.routes')},
            {path: 'tablalimitescanal', canActivate: [canActivatePermiso(MODULO.LIMITES_CANAL, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablalimitescanal/tablalimitescanal.routes')},
            {path: 'tablacitas', canActivate: [canActivatePermiso(MODULO.CITAS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablacitas/tablacitas.routes')},
            {path: 'tablapermiso', canActivate: [canActivatePermiso(MODULO.PERMISOS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablapermiso/tablapermiso.routes')},
            {path: 'tablakiosko', canActivate: [canActivatePermiso(MODULO.KIOSKOS, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablakiosko/example.routes')},
            {path: 'tablasucursal', canActivate: [canActivatePermiso(MODULO.SUCURSALES, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/tablasucursal/example.routes')},
            {path: 'configuracionaplicacion', canActivate: [canActivatePermiso(MODULO.CONFIG_APLICACION, ACCION.EDITAR)], loadChildren: () => import('app/modules/admin/configuracionaplicacion/configuracionaplicacion.routes')},

            {path: 'reporte-turnos', canActivate: [canActivatePermiso(MODULO.REPORTES, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/reporte-turnos/reporte-turnos.routes')},
            {path: 'reporte-turnos-atendidos', canActivate: [canActivatePermiso(MODULO.REPORTES, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/reporte-turnos-atendidos/reporte-turnos-atendidos.routes')},
            {path: 'reporte-comparativo-turnos', canActivate: [canActivatePermiso(MODULO.REPORTES, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/reporte-comparativo-turnos/reporte-comparativo-turnos.routes')},
            {path: 'reporte-citas', canActivate: [canActivatePermiso(MODULO.REPORTES, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/reporte-citas/reporte-citas.routes')},
            {path: 'bitacoraturnos', canActivate: [canActivatePermiso(MODULO.BITACORA_TURNO, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/bitacoraturnos/bitacoraturnos.routes')},
            {path: 'registro-chatbot', canActivate: [canActivatePermiso(MODULO.REGISTRO_CHATBOT, ACCION.CONSULTAR)], loadChildren: () => import('app/modules/admin/registro-chatbot/registro-chatbot.routes')},

            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            // 404 & Catch all
            {path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/admin/pages/error/error-404/error-404.routes')},
            {path: '**', redirectTo: '404-not-found'},

        ]
    }
];
